//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectRampBookings, setRampBookings, setRampBookingsForAllLocations, selectRampBookingsForAllLocations, selectRampBookingsForHCAndHS, setRampBookingsForHCAndHS } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme'

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const RampBookingsSwitch = () => {

    //redux
    const dispatch = useDispatch();
    const rampBookings = useSelector(selectRampBookings); // status of RampBookings switch
    const rampBookingsForAllLocations = useSelector(selectRampBookingsForAllLocations); // status of RampBookingsForAllLocations switch
    const rampBookingsForHCAndHS = useSelector(selectRampBookingsForHCAndHS); // status of RampBookingsForHCAndHS switch
    const usedTheme = useSelector(selectUsedTheme);

    const handleSwitch = () => {
        dispatch(setRampBookings(!rampBookings));
        if (!rampBookings) {
            dispatch(setRampBookingsForAllLocations(false));
        }
    };

    const handleSwitchForAllLocations = () => {
        dispatch(setRampBookingsForAllLocations(!rampBookingsForAllLocations));
    };

    const handleSwitchForHCAndHS = () => {
        dispatch(setRampBookingsForHCAndHS(!rampBookingsForHCAndHS));
    };

    return (


        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        Ramp Bookings
                    </span>
                    <Form.Check
                        onChange={handleSwitch}
                        type="switch"
                        // defaultChecked={rampBookings}
                        checked={rampBookings}
                        value={rampBookings}
                        style={{ marginLeft: '16px' }}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Combine all passengers on flights which are arriving into one airbridge stands and gates.
                </span>

            </div>
            {rampBookings &&
                <>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                                Ramp For All Locations
                            </span>
                            <Form.Check
                                onChange={handleSwitchForAllLocations}
                                type="switch"
                                // defaultChecked={rampBookings}
                                checked={rampBookingsForAllLocations}
                                value={rampBookingsForAllLocations}
                                style={{ marginLeft: '16px' }}
                            />
                        </div>
                        <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                            Show Ramp Bookings for all locations
                        </span>
                    </div>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                                Ramp For WCHC, WCHS
                            </span>
                            <Form.Check
                                onChange={handleSwitchForHCAndHS}
                                type="switch"
                                // defaultChecked={rampBookings}
                                checked={rampBookingsForHCAndHS}
                                value={rampBookingsForHCAndHS}
                                style={{ marginLeft: '16px' }}
                            />
                        </div>
                        <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                            Show Ramp Bookings only for flights with WCHC, WCHS
                        </span>
                    </div>
                </>
            }
        </div>


    )
}

export default RampBookingsSwitch
